/**
 * 악덕알리미 내제보건 상세 — BottomSheet 콘텐츠 렌더 (페이지가 아니라 BS 컴포넌트).
 * 데이터는 서버(/b/ajax/report/{num}, 본인 한정)에서 받아 표시. status 에 따라 본문/버튼이 달라진다.
 *
 *   사용: $j.F.Devil.MyReport.open(reportNum, onChanged)   // My 리스트에서 카드 클릭 시
 *   (내부적으로 $j.Ui.BS.open({ target: new MyReportBS(), data, fixedHeight:true }))
 *
 * status(g5_dv_report.status) 분기:
 *  [A] 리스트 BS(악덕 상세)와 동일 — $j.F.Devil.Render 재사용 (악덕detail + 제보자swipe + 통화목록)
 *   APPROVED(등록)    악덕 상세 + [회수처리/회수완료]
 *   RECALLED(해제)    악덕 상세 (버튼 없음) — 단, 해제 시 master_num=NULL 이면 [B] 폴백
 *  [B] 내제보 detail — 단일 제보 카드(업체정보 + 내 제보내용) + 상태블록
 *   DRAFT(임시)        + 임시저장 안내            / [삭제] [수정]
 *   SUBMITTED(심사대기) + 심사 대기중              / —
 *   DEFENDING(정정대기) + 정정 요청 기간(ⓘ·카운트다운) / —
 *   REJECTED(반려)     + 반려사유                 / [삭제] [수정]
 *
 * 회원은 철회(recall) 불가 — 등록건 액션은 회수처리(원탭)만 제공한다.
 */
import Util from '../../Common/Util';
const LABEL = { DRAFT: '임시', SUBMITTED: '심사중', DEFENDING: '정정대기', APPROVED: '등록', REJECTED: '반려', RECALLED: '해제' };

// BS 타깃 — BS 가 this.id / this.parent / this.data 주입. (open 마다 새 인스턴스)
class MyReportBS {
    // BS target 진입점 — BS 가 this.id / this.parent / this.data 주입
    init() {
        this.$body = $('#' + this.id);
        this.reportNum = this.data && this.data.reportNum;
        this.onChanged = (this.data && this.data.onChanged) || null;
        this._photos = [];
        if (!this.reportNum) { this.$body.html(this._msg('잘못된 접근입니다.')); return; }
        this.parent && this.parent.setHeader && this.parent.setHeader({ loading: true });   // 제목 자리만 잡아둔다
        this.load();
        this._bind();
    }

    destroy() { this._clearTimer(); this._closeRecover(); $(document).off('.dvmyreport'); }

    load() {
        this.$body.html('<p class="b-detail__loading">불러오는 중…</p>');
        $.get('/b/ajax/report/' + this.reportNum, (res) => {
            if (!res || !res.result) { this._failed((res && res.message) || '불러오기 실패'); return; }
            this.render(res);
        }, 'json').fail(() => this._failed('불러오기 실패'));
    }

    // 못 불러오면 제목 자리(로딩 막대)도 걷는다
    _failed(msg) {
        this.$body.html(this._msg(msg));
        this.parent && this.parent.setHeader && this.parent.setHeader({ title: '내 제보' });
    }

    render(res) {
        const r = res.report;
        const st = r.status;
        const mv = res.master_view;
        this._photos = [];

        // [A] APPROVED·RECALLED + 마스터 데이터 → 리스트 BS(악덕 상세)와 동일.
        //     APPROVED 는 회수처리 버튼 추가, RECALLED 는 버튼 없음.
        if ((st === 'APPROVED' || st === 'RECALLED') && mv && mv.master) {
            this._renderMasterStyle(res, r, st, mv);
            this._clearTimer();
            return;
        }

        // [B] 내제보 detail — DRAFT/SUBMITTED/DEFENDING/REJECTED (마스터 없는 RECALLED 폴백)
        this._renderOwnDetail(res, r, st);
    }

    // [A] 리스트 BS(악덕 상세) 재사용 + (APPROVED) 회수처리 버튼
    _renderMasterStyle(res, r, st, mv) {
        const R = $j.F.Devil.Render;
        this.parent && this.parent.setTitle && this.parent.setTitle(R.masterTitle(mv.master));
        R.renderMasterInto(this.$body, { master: mv.master, reports: mv.reports, calls: mv.calls });

        // 해제 판정 — 제보 해제(RECALLED) 또는 악덕업체 해제(master RELEASED). 회수보다 우선.
        const masterReleased = !!(mv.master && mv.master.status === 'RELEASED');
        const released = st === 'RECALLED' || masterReleased;

        // 해제 사유 노트 — 악덕업체 정보 아래에, 간격 두고 표시
        if (released) {
            const reason = res.release_reason || res.master_release_reason || '';
            const note = reason
                ? `<div class="b-myr__note b-myr__note--rej"><p class="b-myr__note-t">해제 사유</p><p class="b-myr__note-d">${this._esc(reason)}</p></div>`
                : '<div class="b-myr__note">해제된 제보입니다.</div>';
            this.$body.append(`<div style="margin-top:16px">${note}</div>`);
        }

        // 회수처리 버튼 — 등록(APPROVED)이면서 해제 안 된 경우에만 (해제되면 숨김)
        if (st === 'APPROVED' && !released) {
            const recovered = !!r.recovered_at;
            this.$body.append(recovered
                ? '<div class="b-myr__btns"><div class="b-myr__btn b-myr__btn--locked" aria-disabled="true">✓ 전액 회수 완료</div></div>'
                : '<div class="b-myr__btns"><button class="b-myr__btn b-myr__btn--rec dvmyr-recover">💰 회수처리</button></div>');
            // 회수처리(원탭 확인) 모달용 정보 — unpaid 는 숫자 그대로 둔다 (표시용 HTML 은 모달 템플릿에서 R.won 으로 만든다)
            const info = r.bad_info ? (JSON.parse(r.bad_info) || {}) : {};
            this._rec = { co: info['이름'] || mv.master.co_name || '-', phone: mv.master.phone || '', unpaid: r.unpaid_amount };
        }
    }

    // [B] 내제보 detail — 단일 제보 카드(업체정보 + 내 제보 내용) + 상태블록 + 버튼
    _renderOwnDetail(res, r, st) {
        const info = r.bad_info ? (JSON.parse(r.bad_info) || {}) : {};
        const unpaid = $j.F.Devil.Render.won(r.unpaid_amount);

        // 헤더: 업체명 + 전화
        const phone = Util.phoneNumber(info['연락처']);
        this.parent && this.parent.setTitle && this.parent.setTitle(
            `${this._esc(info['이름'] || r.master_co_name || '-')}<span class="b-myr__hp">${this._esc(phone)}</span>`
        );

        // 증빙(신고) 썸네일
        const photos = (res.photos || []).filter(p => p.photo_type === 'REPORT' && p.image_url);
        this._photos = photos.map(p => p.image_url);
        const thumbs = photos.length
            ? `<div class="b-myr__thumbs">${photos.map((p, i) => `<img class="b-myr__thumb dvmyr-photo" data-idx="${i}" src="${this._esc(p.thumb_url || p.image_url)}">`).join('')}</div>`
            : '';

        this.$body.html(`
            <div class="b-myr">
                <div class="b-myr__head">
                    <span class="b-badge ${this._badgeMod(st)}">${this._esc(LABEL[st] || st)}</span>
                    <span class="b-myr__amt">${unpaid}</span>
                </div>
                <p class="b-myr__sub">${this._esc(info['사업자번호'] || '-')} · ${this._esc(info['대표자명'] || '-')}</p>
                <p class="b-myr__sub">${this._esc(info['사업장주소'] || '-')}</p>
                <p class="b-myr__sub b-myr__date">제보일 ${this._esc((r.created_at || '').substr(0, 10))}</p>

                <div class="b-myr__rep">
                    <p class="b-myr__rep-row"><b>작업일·장소</b> ${this._esc(info['피해일'] || '-')} ${this._esc(info['작업지주소'] || '')}</p>
                    <p class="b-myr__rep-row"><b>작업장비</b> ${this._esc(info['작업장비'] || '-')}</p>
                    <p class="b-myr__rep-desc">${this._esc(r.damage_desc || '-')}</p>
                    ${thumbs}
                </div>

                ${this._statusBlock(st, res)}
                ${this._actions(st)}
            </div>
        `);

        // 정정 요청 마감 카운트다운 (실시간)
        if (st === 'DEFENDING' && res.defense && res.defense.due_at) this._startCountdown(res.defense.due_at);
        else this._clearTimer();
    }

    // ── 상태별 본문 블록 (내제보 detail 경로: DRAFT/SUBMITTED/DEFENDING/REJECTED/RECALLED) ──
    _statusBlock(st, res) {
        if (st === 'REJECTED') {
            return `<div class="b-myr__note b-myr__note--rej">
                <p class="b-myr__note-t">반려 사유</p>
                <p class="b-myr__note-d">${this._esc(res.reject_reason || '서류 미비')}</p>
            </div>`;
        }
        if (st === 'DRAFT') {
            return `<div class="b-myr__note">임시저장 상태입니다. 제보를 완료해주세요.</div>`;
        }
        if (st === 'SUBMITTED') {
            return `<div class="b-myr__note">심사 대기중입니다. 관리자 확인 후 결과가 안내됩니다.</div>`;
        }
        if (st === 'DEFENDING') {
            const due = res.defense && res.defense.due_at;
            return `<div class="b-myr__note b-myr__note--sm">
                <div class="b-myr__sm-head">
                    <span class="b-myr__sm-title">
                        <span class="b-myr__note-t">소명·정정 기간</span>
                        <button type="button" class="b-myr__sm-i dvmyr-sm-tog" aria-label="소명·정정 안내">i</button>
                    </span>
                    ${due ? `<span class="b-myr__due">마감 <b>${this._esc(due)}</b></span>` : ''}
                </div>
                ${due ? `<p class="b-myr__cd">등록까지 <span class="b-myr__due-cd">계산 중…</span></p>` : ''}
                <div class="b-myr__sm-info">
                    <p class="b-myr__note-d">• 제보 접수 후 체불업체(자)에게 문자로 소명·정정 기회를 알립니다.<br>• 업체가 안심번호로 전화해 소명(지급·합의)해 올 수 있습니다. 합의되면 고객센터에 철회를 요청해 주세요.<br>• 마감일까지 소명·정정이 없으면 체불로 등록됩니다.<br>• 정정 요청이 들어오면 관리자가 심사합니다. (약 1~2일 소요)<br>• 심사 결과에 따라 체불 등록 또는 제보 철회가 결정됩니다.</p>
                </div>
            </div>`;
        }
        if (st === 'RECALLED') {
            return res.release_reason
                ? `<div class="b-myr__note b-myr__note--rej">
                    <p class="b-myr__note-t">해제 사유</p>
                    <p class="b-myr__note-d">${this._esc(res.release_reason)}</p>
                </div>`
                : `<div class="b-myr__note">해제된 제보입니다.</div>`;
        }
        return '';
    }

    // ── 상태별 버튼 (내제보 detail 경로) — DRAFT/REJECTED 만 삭제·수정 ──
    _actions(st) {
        if (st === 'DRAFT' || st === 'REJECTED') {
            return `<div class="b-myr__btns">
                <button class="b-myr__btn b-myr__btn--ghost dvmyr-del">삭제하기</button>
                <button class="b-myr__btn b-myr__btn--edit dvmyr-edit">수정하기</button>
            </div>`;
        }
        return '';
    }

    _bind() {
        const self = this;
        // 증빙 확대
        $(document).on('click.dvmyreport', '.dvmyr-photo', function () {
            const i = parseInt($(this).data('idx'), 10) || 0;
            if (self._photos.length && $j.Ui.ZoomPhoto) {
                $j.Ui.ZoomPhoto.open(null, { items: self._photos.map(u => ({ url: u })), index: i });
            }
        });
        // 수정 → 작성 페이지
        $(document).on('click.dvmyreport', '.dvmyr-edit', () => location.replace('/b/report?num=' + self.reportNum));
        // 삭제(하드)
        $(document).on('click.dvmyreport', '.dvmyr-del', () => {
            if (!confirm('삭제된 제보는 복구할 수 없습니다. 삭제할까요?')) return;
            $.post('/b/ajax/report/' + self.reportNum + '/delete', (res) => self._after(res, '삭제되었습니다.'), 'json');
        });
        // 회수처리 모달 열기
        $(document).on('click.dvmyreport', '.dvmyr-recover', () => self._openRecover());
        // 소명 안내 ⓘ 토글 (펼침/접힘)
        $(document).on('click.dvmyreport', '.dvmyr-sm-tog', function () {
            $(this).closest('.b-myr__note--sm').find('.b-myr__sm-info').toggleClass('is-open');
        });
    }

    // ── 회수처리 (원탭 확인 다이얼로그) — 일부회수 없음, 전액 회수만 ──
    _openRecover() {
        const self = this;
        const rec = this._rec || {};
        const unpaid = $j.F.Devil.Render.won(rec.unpaid);   // 숫자로 만든 HTML(span) — _esc 로 감싸면 태그가 글자로 찍힌다
        this._closeRecover(); // 중복 방지
        const $ov = $(`
            <div class="b-overlay b-recov" id="b-recov-ov">
                <div class="b-dialog b-recov__dlg">
                    <div class="b-recov__head">
                        <span class="b-recov__title">전액 회수 처리</span>
                        <button type="button" class="b-recov__x dvrec-x" aria-label="닫기">&times;</button>
                    </div>
                    <div class="b-recov__body">
                        <div>
                            <p class="b-recov__co">${this._esc(rec.co || '-')}</p>
                            <p class="b-recov__sub">${this._esc(rec.phone || '')} · ${unpaid}</p>
                        </div>
                        <p class="b-recov__confirm">체불금액 <b>${unpaid}</b>을 전액 회수하셨습니까?<br>처리 후에는 <b>수정·취소가 불가</b>합니다.</p>
                    </div>
                    <button type="button" class="b-recov__ok dvrec-ok">전액 회수 완료 처리</button>
                </div>
            </div>`);
        $('body').append($ov);
        this._$recov = $ov;

        // 닫기 (X / 오버레이 바깥)
        $ov.on('click', '.dvrec-x', () => self._closeRecover());
        $ov.on('click', (e) => { if (e.target === $ov[0]) self._closeRecover(); });

        // 전액 회수 완료 처리 (원탭) — 회수일은 서버가 오늘로 설정
        $ov.on('click', '.dvrec-ok', () => {
            $.post('/b/ajax/report/' + self.reportNum + '/recovered', {}, (res) => {
                if (!res || !res.result) {
                    window.BD && BD.toast ? BD.toast((res && res.message) || '처리 실패') : alert((res && res.message) || '처리 실패');
                    return;
                }
                self._closeRecover();
                self._after(res, '전액 회수 처리되었습니다.', false);
            }, 'json');
        });
    }

    _closeRecover() {
        if (!this._$recov) return;
        this._$recov.remove();
        this._$recov = null;
    }

    // 소명 마감 카운트다운
    _startCountdown(dueStr) {
        this._clearTimer();
        const due = new Date(String(dueStr).replace(' ', 'T'));
        if (isNaN(due.getTime())) return;
        const tick = () => {
            const $el = this.$body.find('.b-myr__due-cd');
            if (!$el.length) { this._clearTimer(); return; }
            const ms = due.getTime() - Date.now();
            if (ms <= 0) { $el.text('마감'); this._clearTimer(); return; }
            const m = Math.floor(ms / 60000), d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mm = m % 60;
            $el.text((d ? d + '일 ' : '') + h + '시간 ' + mm + '분 남음');
        };
        tick();
        this._timer = setInterval(tick, 30000);
    }
    _clearTimer() { if (this._timer) { clearInterval(this._timer); this._timer = null; } }

    // 액션 후 처리 — close 면 BS 닫고 목록 갱신, 아니면 상세 새로고침
    _after(res, okMsg, close = true) {
        if (!res || !res.result) { window.BD && BD.toast ? BD.toast(res.message || '처리 실패') : alert(res.message || '처리 실패'); return; }
        window.BD && BD.toast && BD.toast(okMsg);
        if (this.onChanged) this.onChanged();
        if (close) { this.parent && this.parent.close && this.parent.close(); }
        else { this.load(); }
    }

    // ── helpers ──
    _badgeMod(st) {
        return { DRAFT: 'b-badge--d', SUBMITTED: 'b-badge--sub', DEFENDING: 'b-badge--sm',
                 APPROVED: 'b-badge--r', REJECTED: 'b-badge--rj', RECALLED: 'b-badge--d' }[st] || 'b-badge--d';
    }
    _msg(t) { return `<p class="b-detail__loading">${this._esc(t)}</p>`; }
    _esc(s) { return $j.F.Devil.Render.esc(s); }
}

// $j.F.Devil.MyReport — opener (F/Devil/Master 와 동일 패턴). open 마다 새 BS 타깃 생성.
export default class MyReport {
    open = (reportNum, onChanged) => {
        $j.Ui.BS.open({ target: new MyReportBS(), data: { reportNum, onChanged }, fixedHeight: true, backClose: true });
    }
}
